export default __webpack_public_path__ + "static/media/btn_close.345dd5dc.svg";